<template>
  <div class="row event-list">
    <div
      :class="{
        'col-12': !showDetailsPane,
        'col-8 details-pane-open': showDetailsPane,
      }"
    >
      <ListTable
        :items="items"
        :columns="columns"
        :activeColumns="activeColumns"
        :hideNoResults="hideNoResults"
        :hasDetailsPane="showDetailsPane"
        @sort-by="setSort"
        @swap-column="setActiveColumn"
        @item-clicked="setSelectedItem"
      >
        <template v-slot:col_start_date="{ item }">{{
          item.startDate
        }}</template>
        <template v-slot:col_end_date="{ item }">{{ item.endDate }}</template>
        <template v-slot:col_timezone="{ item }">{{
          item.timezone_abbreviation
        }}</template>
        <template v-slot:col_city="{ item }">{{
          item.city_and_state
        }}</template>
        <template v-slot:col_location="{ item }">{{
          !!item.is_virtual ? "Virtual" : item.location
        }}</template>
        <template v-slot:col_price="{ item }">{{
          item.enrollment_price | cost
        }}</template>
        <template v-slot:col_status="{ item }">{{
          item.status_label
        }}</template>
        <template v-slot:col_est_trainer_travel_fee="{ item }">{{
          item.est_trainer_travel_fee | cost
        }}</template>
        <template v-slot:col_act_trainer_travel_fee="{ item }">{{
          item.act_trainer_travel_fee | cost
        }}</template>
        <template v-slot:col_est_trainer_course_fee="{ item }">{{
          item.est_trainer_course_fee | cost
        }}</template>
        <template v-slot:col_act_trainer_course_fee="{ item }">{{
          item.act_trainer_course_fee | cost
        }}</template>
        <template v-slot:col_est_materials_fee="{ item }">{{
          item.est_materials_fee | cost
        }}</template>
        <template v-slot:col_act_materials_fee="{ item }">{{
          item.act_materials_fee | cost
        }}</template>
        <template v-slot:col_distributor_billing_amount="{ item }">{{
          item.distributor_billing_amount | cost
        }}</template>
        <template v-slot:col_distributor_billing_fee="{ item }">{{
          item.distributor_billing_fee | cost
        }}</template>
        <template v-slot:col_distributor_billing_date="{ item }">{{
          item.distributor_billing_date | moment("MM/DD/YYYY")
        }}</template>
        <template v-slot:col_trainer_invoice_date="{ item }">{{
          item.trainer_invoice_date | moment("MM/DD/YYYY")
        }}</template>
        <template v-slot:col_trainer_rsvp="{ item }">{{
          item.trainer_rsvp_label
        }}</template>
        <template v-slot:col_closed_at="{ item }">{{
          item.closed_at | moment("MM/DD/YYYY")
        }}</template>
        <template v-slot:col_roster_uploaded_at="{ item }">{{
          item.roster_uploaded_at | moment("MM/DD/YYYY")
        }}</template>
        <template v-slot:col_created_at="{ item }">{{
          item.created_at | moment("MM/DD/YYYY")
        }}</template>
        <template v-slot:col_updated_at="{ item }">{{
          item.updated_at | moment("MM/DD/YYYY")
        }}</template>
        <template v-slot:list-card="{ item, id }">
          <ListCard
            :item="item"
            :id="id"
            :eventBus="listEvents"
            :section="section"
          />
        </template>
        <template v-slot:list-menu="{ item, id }">
          <ListMenu
            :item="item"
            :id="id"
            :eventBus="listEvents"
            :section="section"
            :cancellation-types="cancellationTypes"
          />
        </template>
      </ListTable>
    </div>
    <div v-if="showDetailsPane" class="col-4 details-pane-wrap mb-3">
      <DetailsPane
        :event="selectedItem"
        :tab="selectedTab"
        :section="section"
        @close="setSelectedItem(null)"
      />
    </div>
  </div>
</template>

<script>
import CancelEventModal from 'components/pages/admin/events/partials/CancelEventModal'
import ListTable from "components/listings/Table";
import ListCard from "./ListCard";
import ListMenu from "./ListMenu";
import DetailsPane from "./DetailsPane";

export default {
    components: {ListTable, ListCard, ListMenu, DetailsPane},

    props: {
        items: {type: Array, default: () => []},
        columns: {type: Array, default: () => []},
        activeColumns: {type: Array, default: () => []},
        hideNoResults: {type: Boolean, default: true},
        listEvents: {type: Object, required: true},
        section: {type: String, default: "training"},
        cancellationTypes: {type: Array, default: () => []}
    },

    data() {
        return {
            selectedItem: null,
            selectedTab: null,
        };
    },

    computed: {
        showDetailsPane() {
            return !! this.selectedItem;
        },
    },

    methods: {
        handleMenuAction(action, item) {
            const handlers = {
                'remove': this.delete,
                'cancel': this.cancel
            }

            const handler = handlers[action];

            if (handler) {
                handler(item)
            }
        },

        setSelectedItem(item, tab) {
            this.selectedItem = item;
            this.selectedTab = tab || null;
        },

        setSort(column, dir) {
            this.$emit("sort-by", column, dir);
        },

        setActiveColumn(column, index) {
            this.$emit("swap-column", column, index);
        },

        cancel(item) {
            this.$modal(CancelEventModal, {
                event: item,
                cancellationTypes: this.cancellationTypes,
            })
                .then(() => {
                    this.listEvents.$emit("refresh");
                    this.listEvents.$emit(
                        "show-alert",
                        "success",
                        `"${item.name}" has been canceled.`,
                        true
                    );
                })
                .catch();
        },


        delete(item) {
            if (confirm(`Are you sure you would like to remove: "${item.name}"?`)) {
                this.axios
                    .delete(this.route("admin.events.destroy", {event: item.id}))
                    .then(() => {
                        this.listEvents.$emit("refresh");
                        this.listEvents.$emit(
                            "show-alert",
                            "success",
                            `"${item.name}" has been removed`,
                            true
                        );
                    });
            }
        },
    },

    mounted() {
        this.listEvents.$on("menu-action", this.handleMenuAction);
        this.listEvents.$on("show-details-pane", this.setSelectedItem);
    },
};
</script>